import { useEffect, useState } from "react";

import { verifyEmail } from "@artegeie/mona-sdk/auth";

import useTranslation from 'Hooks/useTranslation';

import 'scss/components/content/account.scss';

export default function AccountVerifyEmail() {

	const { t } = useTranslation();

	const queryParams = new URLSearchParams(window.location.search);
	const vtoken = queryParams.get('vtoken');

	const { blogUrl } = window.appConfig;

	const [submitting, setSubmitting] = useState(false);
	const [error, setError] = useState(false);

	useEffect(() => {
		setSubmitting(true);
		verifyEmail(vtoken )
		.then( () => {
			setSubmitting(false);

			window.location.href = blogUrl
		} )
		.catch( (response) => {
			setSubmitting(false);
			setError( error.message + "\n" + response );
		});
	}, [ vtoken, setSubmitting, setError ] );

	return (

		<div id='account-page' className="account-verify-email">
		{submitting &&
			<div>
				{ t('submitting') }
			</div>
		}

		{ error && <div className='error-messages'>{ error }</div>}
		</div>
	);
};

